import { SingleLineText } from './SingleLineText';
import { Theme } from '@mui/material/styles';

export type TagProps = {
  text: any;
  disabled?: boolean;
  color?: string;
  backgroundColor?: string;
};

const Tag = ({ text, disabled, backgroundColor, color }: TagProps) => {
  const styleProps = {
    backgroundColor: backgroundColor || '#faa3ba',
    color: color || 'black',
  };
  return (
    <SingleLineText
      text={text}
      sx={(theme: Theme) => {
        if (disabled) {
          return {
            padding: '4.5px 16px',
            borderRadius: '12px',
            backgroundColor: theme.palette.neutral[10],
            color: theme.palette.neutral.black,
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
          };
        }
        return {
          padding: '4.5px 16px',
          borderRadius: '5px',
          color: styleProps.color,
          backgroundColor: styleProps.backgroundColor,
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
        };
      }}
    />
  );
};

export default Tag;
export { Tag };
